import React, { useEffect, useState } from "react";
import "../css/wb_delivery_report.css";
import { apiCall } from "../services/authServieces";
import SearchIcon from "@mui/icons-material/Search";
import { ClipLoader } from "react-spinners";
import excelIcon from "../Assets/images/excel.png"



const WbDeliveryReport = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [mobilesrch, setmobilesrch] = useState("");
  const [activeTab, setActiveTab] = useState("WhatsApp");
  const [smsData, setSmsData] = useState([]);
  const [debouncedQuery, setDebouncedQuery] = useState(mobilesrch);
  const [skipDebounce, setSkipDebounce] = useState(false);

  // Filter states
  const [filterType, setFilterType] = useState("all"); // all | dealer
  const [dealerList, setDealerList] = useState([]);   // dealer dropdown
  const [selectedDealer, setSelectedDealer] = useState("");
  const [showpagi, setshowpagi] = useState(false);

  const user = JSON.parse(localStorage.getItem("user-cred"));
  const networkType = user?.user?.networkType || "";
  const itemsPerPage = 10; // page limit

  // Fetch dealers list for dropdown
  // const fetchDealersList = async () => {
  //   try {
  //     const res = await apiCall({
  //       endpoint: `api/dealers/get-users-by-main-dealer`,
  //       method: "GET",
  //     });

  //     if (res.success && res.data) {
  //       setDealerList(res.data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching dealers list:", error);
  //   }
  // };

  // WhatsApp data fetch functions
  const fetchWhatsAppData = async (page, debouncedQuery = "") => {
    setLoading(true);
    try {
      const res = await apiCall({
        endpoint: `api/dealers/get-deliveryreport?page=${page}&limit=${itemsPerPage}&search=${debouncedQuery}`,
        method: "GET",
      });

      const result = res;
      setData(result.items ?? []);
      setDealerList(result.data);
      setTotalPages(Math.ceil(result.total / itemsPerPage) ?? 0);
    } catch (error) {
      console.error("Error fetching WhatsApp data:", error);
    } finally {
      setLoading(false);
    }
  };

  // WhatsApp All Data Fetch Function
  const fetchWhatsAppAllData = async (page = 1, debouncedQuery = "") => {
    setLoading(true);
    try {
      const res = await apiCall({
        endpoint: `api/dealers/get-delivery-all-report?page=${page}&limit=${itemsPerPage}&search=${debouncedQuery}`,
        method: "GET",
      });

      const result = res;
      setData(result.items ?? []);
      setTotalPages(Math.ceil(result.total / itemsPerPage) ?? 0);
    } catch (error) {
      console.error("Error fetching WhatsApp all data:", error);
    } finally {
      setLoading(false);
    }
  };

  // WhatsApp Dealer Wise Data Fetch Function
  const fetchWhatsAppDealerData = async (dealerId, page = 1, debouncedQuery = "") => {
    if (!dealerId) return;
    setLoading(true);
    try {
      const res = await apiCall({
        endpoint: `api/dealers/get-delivery-dealer-wise?page=${page}&limit=${itemsPerPage}&search=${debouncedQuery}&dealerId=${dealerId}`,
        method: "GET",
      });

      const result = res;
      setData(result.items ?? []);
      setTotalPages(Math.ceil(result.total / itemsPerPage) ?? 0);
    } catch (error) {
      console.error("Error fetching WhatsApp dealer data:", error);
    } finally {
      setLoading(false);
    }
  };

  // SMS data fetch functions
  const fetchSmsData = async (page, debouncedQuery = "") => {
    setLoading(true);
    try {
      const res = await apiCall({
        endpoint: `api/dealers/get-deliverySmsReport?page=${page}&limit=${itemsPerPage}&search=${debouncedQuery}`,
        method: "GET",
      });

      const result = res;
      setSmsData(result.items ?? []);
      setTotalPages(Math.ceil(result.total / itemsPerPage) ?? 0);
    } catch (error) {
      console.error("Error fetching SMS data:", error);
    } finally {
      setLoading(false);
    }
  };

  // SMS All Data Fetch Function
  const fetchSmsAllData = async (page = 1, debouncedQuery = "") => {
    setLoading(true);
    try {
      const res = await apiCall({
        endpoint: `api/dealers/get-deliverySmsReport?page=${page}&limit=${itemsPerPage}&search=${debouncedQuery}`,
        method: "GET",
      });

      const result = res;
      setSmsData(result.items ?? []);
      setTotalPages(Math.ceil(result.total / itemsPerPage) ?? 0);
    } catch (error) {
      console.error("Error fetching SMS all data:", error);
    } finally {
      setLoading(false);
    }
  };

  // SMS Dealer Wise Data Fetch Function
  const fetchSmsDealerData = async (dealerId, page = 1, debouncedQuery = "") => {
    if (!dealerId) return;
    setLoading(true);
    try {
      const res = await apiCall({
        endpoint: `api/dealers/get-sms-dealer-wise?page=${page}&limit=${itemsPerPage}&search=${debouncedQuery}&dealerId=${dealerId}`,
        method: "GET",
      });

      const result = res;
      setSmsData(result.items ?? []);
      setTotalPages(Math.ceil(result.total / itemsPerPage) ?? 0);
    } catch (error) {
      console.error("Error fetching SMS dealer data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Main data fetching function based on current state
  const fetchCurrentData = (page = currentPage, query = debouncedQuery) => {
    if (activeTab === "WhatsApp") {
      if (filterType === "all") {
        fetchWhatsAppAllData(page, query);
      } else if (filterType === "dealer" && selectedDealer) {
        fetchWhatsAppDealerData(selectedDealer, page, query);
      } else {
        fetchWhatsAppData(page, query);
      }
    } else if (activeTab === "SMS") {
      if (filterType === "all") {
        fetchSmsAllData(page, query);
      } else if (filterType === "dealer" && selectedDealer) {
        fetchSmsDealerData(selectedDealer, page, query);
      } else {
        fetchSmsData(page, query);
      }
    }
  };

  // Load dealers list when component mounts if user is Main Dealer
  // useEffect(() => {
  //   if (networkType === "Main Dealer") {
  //     fetchDealersList();
  //   }
  // }, [networkType]);

  // Fetch data when tab, page, or filter changes
  useEffect(() => {
    fetchCurrentData(currentPage);
  }, [currentPage, activeTab, filterType, selectedDealer]);

  // Fetch data when search query changes
  useEffect(() => {
    if (currentPage === 1) {
      fetchCurrentData(1, debouncedQuery);
    } else {
      setCurrentPage(1); // This will trigger the above useEffect
    }
  }, [debouncedQuery]);

  // Debounce search input
  useEffect(() => {
    if (skipDebounce) {
      setSkipDebounce(false);
      return;
    }

    const timeoutId = setTimeout(() => {
      setDebouncedQuery(mobilesrch);
    }, 1500);
    return () => clearTimeout(timeoutId);
  }, [mobilesrch]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Create pagination array
  const createPagination = () => {
    const pagesToShow = 1;
    let pages = [];

    pages.push(1);

    if (currentPage > pagesToShow + 2) {
      pages.push(null);
    }

    for (
      let i = Math.max(2, currentPage - pagesToShow);
      i <= Math.min(totalPages - 1, currentPage + pagesToShow);
      i++
    ) {
      pages.push(i);
    }

    if (currentPage < totalPages - pagesToShow - 1) {
      pages.push(null);
    }

    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages;
  };

  const handleTabClick = (tab) => {
    setSkipDebounce(true);
    setmobilesrch("");
    setActiveTab(tab);
    setCurrentPage(1);
    // Reset filter when changing tabs
    setFilterType("all");
    setSelectedDealer("");
  };

  // Handle filter type change
  const handleFilterChange = (newFilterType) => {
    setFilterType(newFilterType);
    setCurrentPage(1);

    if (newFilterType === "all") {
      setSelectedDealer("");
    }
  };

  // Handle dealer selection change
  const handleDealerChange = (dealerId) => {
    setSelectedDealer(dealerId);
    setCurrentPage(1);
  };

  const handleDownload = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user-cred"));
      const token = user?.token;
      const baseURL = process.env?.REACT_APP_API_URL;

      // Determine which download endpoint to use based on current filters
      let apiUrl = "";
      if (activeTab === "WhatsApp") {
        if (filterType === "all") {
          apiUrl = `${baseURL}/api/dealers/download-whatsapp-all-report`;
        } else if (filterType === "dealer" && selectedDealer) {
          apiUrl = `${baseURL}/api/dealers/download-whatsapp-dealer-report?dealerId=${selectedDealer}`;
        } else {
          apiUrl = `${baseURL}/api/dealers/download-whatsapp-report`;
        }
      } else {
        if (filterType === "all") {
          apiUrl = `${baseURL}/api/dealers/download-sms-all-report`;
        } else if (filterType === "dealer" && selectedDealer) {
          apiUrl = `${baseURL}/api/dealers/download-sms-dealer-report?dealerId=${selectedDealer}`;
        } else {
          apiUrl = `${baseURL}/api/dealers/download-sms-report`;
        }
      }

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to download file');
      }

      const blob = await response.blob();

      // Extract filename
      let filename = `${activeTab.toLowerCase()}_delivery_report.csv`;
      const disposition = response.headers.get('Content-Disposition') || response.headers.get('content-disposition');
      if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1]);
        }
      }

      // Download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Download error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="Delivery_report_contian">
        <h4 className="Head_title Delivery_heading Head_title Delivery_heading_new">
          <div className="custom_header_btn_group mx-2">
            <button
              className={`custom_tab_btn ${activeTab === "WhatsApp" ? "active" : ""}`}
              onClick={() => handleTabClick("WhatsApp")}
            >
              WhatsApp
            </button>
            <button
              className={`custom_tab_btn ${activeTab === "SMS" ? "active" : ""}`}
              onClick={() => handleTabClick("SMS")}
            >
              SMS
            </button>
          </div>
          <span className="custom_report_title custom_report_title_new">Today Delivery Report</span>
          <div className="custom_SearchContain">
            <div className="custom_filter_section">
              <select
                className="custom_dropdown"
                value={filterType}
                onChange={(e) => handleFilterChange(e.target.value)}
              >
                <option value="all">All</option>
                {networkType === "Main Dealer" && (
                  <option value="dealer">Dealer Wise</option>
                )}
              </select>

              {filterType === "dealer" && networkType === "Main Dealer" && (
                <select
                  className="custom_dropdown"
                  value={selectedDealer}
                  onChange={(e) => handleDealerChange(e.target.value)}
                  disabled={dealerList.length === 0}
                >
                  <option value="">Select Dealer</option>
                  {dealerList.map((dealer, index) => (
                    <option key={index} value={dealer.user_id}>
                      {dealer.user_id}
                    </option>
                  ))}
                </select>
              )}
            </div>

            <div className="custom_search_box">
              <input
                type="text"
                placeholder="Search by mobile..."
                value={mobilesrch}
                onChange={(e) => setmobilesrch(e.target.value)}
              />
              <button type="button" className="custom_search_btn">
                <SearchIcon />
              </button>
            </div>

            <button
              type="button"
              className="custom_excel_btn me-2"
              onClick={handleDownload}
            >
              <img src={excelIcon} alt="excelIcon" className="custom_excel_icon" />
            </button>
          </div>
        </h4>



        {activeTab === "WhatsApp" && (
          <>
            <div className="Delivery_report_Card">
              <div className="table_contain_deliveryReport">
                <table className="Table" id="Table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Mobile</th>
                      <th>Whatsapp Message</th>
                      <th>Category</th>
                      <th>Type</th>
                      <th>Status</th>
                      {filterType === "all" && <th>Dealer ID</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {item.send_date} {item.send_time}
                        </td>
                        <td>{item.sender_mobile}</td>
                        <td>{item.msg}</td>
                        <td>{item.temp_category}</td>
                        <td className="RunninFont">{item.msg_type}</td>
                        <td className="RunninFont">{item.delivery_status}</td>
                        {filterType === "all" && <td>{item.user_id || item.created_by}</td>}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className={`pagination ${showpagi ? "d-none" : ""}`}>
              {createPagination().map((page, index) =>
                page === null ? (
                  <span key={index} className="ellipsis">
                    ...
                  </span>
                ) : (
                  <button
                    key={index}
                    className={`page-button ${currentPage === page ? 'active' : ''}`}
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </button>
                )
              )}
            </div>
          </>
        )}

        {activeTab === "SMS" && (
          <>
            <div className="Delivery_report_Card">
              <div className="table_contain_deliveryReport">
                <table className="Table" id="Table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Mobile</th>
                      <th>SMS Message</th>
                      <th>Type</th>
                      <th>Status</th>
                      {filterType === "all" && <th>Dealer ID</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {smsData.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {item.send_date} {item.send_time}
                        </td>
                        <td>{item.sender_mobile}</td>
                        <td>{item.msg}</td>
                        <td className="RunninFont">{item.msg_type}</td>
                        <td className="RunninFont">{item.delivery_status}</td>
                        {filterType === "all" && <td>{item.user_id || item.created_by}</td>}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className={`pagination ${showpagi ? "d-none" : ""}`}>
              {createPagination().map((page, index) =>
                page === null ? (
                  <span key={index} className="ellipsis">
                    ...
                  </span>
                ) : (
                  <button
                    key={index}
                    className={`page-button ${currentPage === page ? 'active' : ''}`}
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </button>
                )
              )}
            </div>
          </>
        )}
      </div>

      {loading && (
        <div className="spinnerOverlay">
          <ClipLoader loading={loading} size={50} />
        </div>
      )}
    </>
  );
};

export default WbDeliveryReport;